<a [href]="appUrl" target="_blank">
  @if (badgeUrl) {
<img [src]="badgeUrl"/>
}
</a>
